import { supabase } from "../../../../supabaseClient.js";


export async function insertarVenta({ id_factura, venta }) {
  const { data, error } = await supabase
    .from("ventas")
    .insert({
      ...venta,
      id_factura,
    })
    .select("id_venta")
    .single();

  if (error) throw error;
  return data;
}



